import React from "react";
import Checkbox from "@mui/material/Checkbox";

/**
 * Shared boolean-setting card used across the training editors so every
 * toggle setting looks identical: a bordered card, the checkbox on the LEFT,
 * title + description on the right, and optional expanded content (e.g. a
 * threshold input) rendered inside the card when the setting is on.
 *
 * Props:
 *  - checked: boolean
 *  - onChange: (newValue: boolean) => void
 *  - title: string
 *  - description?: string | node
 *  - disabled?: boolean
 *  - children?: node  (expanded content shown inside the card)
 */
function SettingToggleCard({
  checked,
  onChange,
  title,
  description,
  disabled,
  children,
}) {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
      <label className="flex items-start gap-2 cursor-pointer">
        <Checkbox
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          size="small"
          sx={{
            p: 0,
            mt: "2px",
            color: "#6d28d9",
            "&.Mui-checked": { color: "#6d28d9" },
          }}
        />
        <div className="flex-1">
          <div className="text-sm font-medium text-slate-900">{title}</div>
          {description ? (
            <p className="text-xs text-slate-500 mt-0.5">{description}</p>
          ) : null}
        </div>
      </label>
      {children ? <div className="mt-3">{children}</div> : null}
    </div>
  );
}

export default SettingToggleCard;
